"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.AuthorisationContextConsumer = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    defaults = {
  organisationMemberships: void 0,
  isShootsta: !1,
  isShootstaEditor: !1,
  isShootstaAdmin: !1,
  selectedOrganisation: void 0,
  updateSelectedOrganisation: void 0,
  updateSelectedOrganisationData: void 0
},
    authorisationContext = _react["default"].createContext(defaults),
    _default = authorisationContext;

exports["default"] = _default;
var AuthorisationContextConsumer = authorisationContext.Consumer;
exports.AuthorisationContextConsumer = AuthorisationContextConsumer;